import script from "./LeitnerBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./LeitnerBox.vue?vue&type=script&setup=true&lang=ts"

import "./LeitnerBox.vue?vue&type=style&index=0&id=460d7bf4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-460d7bf4"]])

export default __exports__